<template>
  <div class="print">
    <!-- 1. 헤더 및 결재란 -->
    <section>
      <table>
        <colgroup>
          <col width="160"/>
          <col width="220"/>
          <col width="800"/>
          <col width="100"/>
          <col width="100"/>
          <col width="100"/>
          <col width="100"/>
        </colgroup>
        <tr>
          <th class="gray">{{ $t("회사명") }}</th>
          <td>{{ form.stdInfo.field_name }}</td>
          <td rowspan="4">
            <span class="print-title">{{$t('위험성평가표(3등급)')}}<br/>{{$t('주간 이행사항 점검 및 회의')}}</span>
          </td>
          <th colspan="4" class="gray">{{ $t("확인자") }}</th>
        </tr>
        <tr>
          <th class="gray">{{ $t("작성자") }}</th>
          <td>{{ form.stdInfo.writer_name }}</td>
          <th class="gray">{{ $t("작성자") }}</th>
          <th class="gray">{{ $t("검토자") }}</th>
          <th class="gray">{{ $t("회람자") }}</th>
          <th class="gray">{{ $t("승인자") }}</th>
        </tr>
        <tr>
          <th class="gray" rowspan="2">{{ $t("작성일") }}</th>
          <td rowspan="2">{{ form.stdInfo.date }}</td>
          <td rowspan="2" style="vertical-align: middle; height: 100px;">
            <div class="signature-container">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" class="signature-image" />
              <p v-else-if="form.sign1.name" class="name-text">{{ form.sign1.name }}</p>
            </div>
          </td>
          <td rowspan="2" style="vertical-align: middle; height: 100px;">
            <div class="signature-container">
              <img v-if="form.sign2.sign" :src="form.sign2.sign" class="signature-image" />
              <p v-else-if="form.sign2.name" class="name-text">{{ form.sign2.name }}</p>
            </div>
          </td>
          <td rowspan="2" style="vertical-align: middle; height: 100px;">
            <div class="signature-container">
              <img v-if="form.sign3.sign" :src="form.sign3.sign" class="signature-image" />
              <p v-else-if="form.sign3.name" class="name-text">{{ form.sign3.name }}</p>
            </div>
          </td>
          <td rowspan="2" style="vertical-align: middle; height: 100px;">
            <div class="signature-container">
              <img v-if="form.sign4.sign" :src="form.sign4.sign" class="signature-image" />
              <p v-else-if="form.sign4.name" class="name-text">{{ form.sign4.name }}</p>
            </div>
          </td>
        </tr>
        <tr>
          <!-- 작성일 행의 나머지 TD들이 위에서 rowspan으로 처리됨 -->
        </tr>
      </table>

      <!-- 2. 주간 이행사항 점검 및 회의 (implement) -->
      <table class="mt-auto">
        <colgroup>
          <col width="64" />
          <col width="160" />
          <col />
          <col width="228" />
          <col style="width: 500px;" />
        </colgroup>
        <thead>
          <tr>
            <th colspan="5" class="text-left">❶ {{$t('주간 이행사항 점검 및 회의')}}</th>
          </tr>
          <tr>
            <th>{{ $t("주차") }}</th>
            <th>{{ $t("기간") }}</th>
            <th>{{ $t("⑧ 주간 위험성평가 결과 논의·공유 및 이행상황 점검") }}</th>
            <th>{{ $t("주간 점검 회의 일정") }}</th>
            <th>{{ $t("주간 점검회의 참석자 확인") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="form.implement.length === 0">
            <td colspan="5" class="text-left">{{ $t('작성된 내용이 없습니다.') }}</td>
          </tr>
          <template v-else>
            <tr v-for="(item, item_i) in form.implement" :key="item.id">
              <th class="gray">{{ $t("n주차", { n: item_i + 1 }) }}</th>
              <td>
                <div class="flex flex-col items-center">
                  <div>{{ item.input1_s }}</div>
                  <div class="my-1">~</div>
                  <div>{{ item.input1_e }}</div>
                </div>
              </td>
              <td class="text-left">
                <div>{{ item.input2 }}</div>
              </td>
              <td>
                <div class="flex flex-col text-left px-2">
                  <div class="flex items-center mb-2">
                    <p class="mr-2" style="width: 70px; font-weight: bold;">{{ $t("예정일자") }}</p>
                    <span>{{ item.input3 }}</span>
                  </div>
                  <div class="flex items-center">
                    <p class="mr-2" style="width: 70px; font-weight: bold;">{{ $t("실시일자") }}</p>
                    <span>{{ item.input4 }}</span>
                  </div>
                </div>
              </td>
              <td class="text-left">
                <div>{{ getAttendeeList(item) }}</div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </section>

    <!-- 3. 참석자 명단 (managerList) -->
    <section>
      <table>
        <thead>
          <tr>
            <th colspan="5" class="text-left">❷ {{ $t('참석자 명단') }}</th>
          </tr>
          <tr>
            <th>{{ $t('소속명') }}</th>
            <th>{{ $t('직급') }}</th>
            <th>{{ $t('직책') }}</th>
            <th>{{ $t('이름') }}</th>
            <th>{{ $t('서명') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="form.managerList.length === 0">
            <td colspan="5" class="text-left">{{ $t('작성된 내용이 없습니다.') }}</td>
          </tr>
          <template v-else>
            <tr v-for="(item, index) in form.managerList" :key="`manager_${index}`">
              <td>{{ item.target }}</td>
              <td>{{ item.position }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.name }}</td>
              <td style="height: 60px; vertical-align: middle;">
                <div class="signature-container" style="height: 50px;">
                  <img v-if="item.sign" :src="item.sign" class="signature-image" style="max-height: 40px;" />
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </section>

    <!-- 4. 사진대지 -->
    <section v-if="form.photoList && form.photoList.length > 0">
      <div class="division-title">□ {{ $t('사진대지') }}</div>
      <div class="photo-grid">
        <div v-for="(photo, index) in form.photoList" :key="index" class="photo-item">
          <div class="photo-box">
            <img v-if="photo.path" :src="photo.path" class="grid-photo" />
          </div>
          <div class="photo-desc">{{ photo.input }}</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Print",
  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  },
  methods: {
    getAttendeeList(item) {
      const attendees = [];
      for (let i = 5; i <= 14; i++) {
        const val = item[`input${i}`];
        if (val && val.trim()) {
          attendees.push(val.trim());
        }
      }
      return attendees.join(", ");
    },
  },
};
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 28px;
    font-weight: 700;
    color: #000;
    text-align: center;
    padding: 10px 0;
    line-height: 1.2;
  }
  .division-title {
    font-size: 24px;
    font-weight: 700;
    color: #000;
    padding: 1.25rem 0rem;
  }
  .signature-container {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;

    .signature-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 70px;
      object-fit: contain;
      display: block;
    }
    .name-text {
      font-size: 16px;
      margin-top: 5px;
    }
  }

  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    margin-bottom: 30px;

    th,
    td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 16px;
      padding: 8px;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      word-break: keep-all;
    }
    td {
      word-break: break-word;
    }
    .gray {
      background-color: #ececec;
    }
    .text-left {
      text-align: left;
      padding: 8px 12px;
    }
  }

  .photo-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    width: 100%;
  }
  .photo-item {
    border: 1px solid #757575;
    display: flex;
    flex-direction: column;
  }
  .photo-box {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #757575;
    padding: 10px;
    background: #f9f9f9;

    .grid-photo {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  .photo-desc {
    padding: 10px;
    font-size: 16px;
    min-height: 50px;
    text-align: left;
    background: #fff;
  }
}

@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  table {
    page-break-inside: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .photo-item {
    page-break-inside: avoid;
  }
}
</style>
